import { commentEpic as epic } from "./epic";
import { commentReducer as reducer } from "./reducer";

export const commentEpic = epic
export const commentReducer = reducer
